import React from 'react';

import type { SvgIconClassKey } from '@mui/material';
import { SvgIcon } from '@mui/material';

import { IconColors } from './icon-utils';

export function EmptyCommentsIcon(props: {
  classes?: Partial<Record<SvgIconClassKey, string>>;
}): JSX.Element {
  return (
    <SvgIcon
      classes={props.classes}
      style={{ display: 'block', height: 40, width: 40 }}
      viewBox="0 0 40 40"
    >
      <g fill="none" fillRule="evenodd">
        <g fill={IconColors.LightGray} fillRule="nonzero">
          <g>
            <g>
              <path d="M9.5 37.25l8.8-6.6c.13-.097.288-.15.45-.15h17.5c.966 0 1.75-.784 1.75-1.75v-25C38 2.784 37.216 2 36.25 2H3.75C2.784 2 2 2.784 2 3.75v25c0 .966.784 1.75 1.75 1.75h5c.414 0 .75.336.75.75v6zM8 32H3.75C1.955 32 .5 30.545.5 28.75v-25C.5 1.955 1.955.5 3.75.5h32.5c1.795 0 3.25 1.455 3.25 3.25v25c0 1.795-1.455 3.25-3.25 3.25H19l-9.8 7.35c-.494.37-1.2.018-1.2-.6V32zm.75-18.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h22.5c.414 0 .75.336.75.75s-.336.75-.75.75H8.75zm0 7.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h17.5c.414 0 .75.336.75.75s-.336.75-.75.75H8.75z" />
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
